<template>
  <section id="forgot-password">
    <div class="form-container">
      <div v-if="!resetLinkSent">
        <div class="f-header">
          Forgot Password
        </div>
        <div class="f-sub-header">
          Enter your email and we will send you instructions on how to reset your password.
        </div>
        <div class="input-container margin-top-8">
          <div class="input-header">
            Email
          </div>
          <input id="email" v-model="email" type="email" class="e-input">
        </div>
        <div v-if="error" class="error-message">
          {{ error }}
        </div>
        <button class="send-btn" @click="sendResetEmail">
          <span v-if="!processing">Send Email</span>
          <img v-else src="@shared/assets/img/general/loading-white.svg" class="spinner">
        </button>
        <div class="logo-container">
          <img src="@shared/assets/img/logo/black-logo.png" class="logo" alt="SmartAC.com">
        </div>
      </div>
      <div v-else class="f-body-container">
        <div class="f-header">
          Success
        </div>
        <div class="f-sent-email text-start" style="max-width: 590px;">
          The instructions for updating your password have been sent to your email at <b>{{ email }}</b>
        </div>
        <div class="logo-container">
          <img src="@shared/assets/img/logo/black-logo.png" class="logo" alt="SmartAC.com">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';

import emailValidation from '@shared/lib/errorCatch/emailValidation';

export default {
  name: 'ForgotPasswordView',
  metaInfo: {
    title: 'SmartAC.com | Forgot Password',
  },
  data() {
    return {
      email: '',
      password: '',
      processing: false,
      resetLinkSent: false,
      error: '',
    };
  },
  methods: {
    async sendResetEmail() {
      const trimmedEmail = this.email.trim();
      let error = '';
      if (!trimmedEmail) {
        error = 'Please enter email.';
      } else if (!emailValidation(trimmedEmail)) {
        error = 'Email is not a valid address.';
      }
      this.error = error;
      if (!error) {
        try {
          this.processing = true;
          await axios({
            method: 'POST',
            url: `${process.env.API_URL}/auth/admin/forgot-password`,
            data: {
              email: this.email.trim(),
            },
          });
          this.resetLinkSent = true;
        } catch (err) {
          if (err.response) {
            const {
              data,
            } = err.response;
            if (data) {
              const {
                message,
              } = data;
              this.error = message;
            }
          } else {
            this.error = err;
          }
        }
        this.processing = false;
      }
    },
  },
};
</script>

<style lang="scss">
section#forgot-password {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  overflow: hidden;
  background-color: $WHITE;

  .f-body-container {
    min-width: 600px;
    width: 40%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media (max-width: 768px) {
      padding: 0 100px;
      width: 100%;
      min-width: 0;
    }

    @media (max-width: 425px) {
      padding: 0 40px;
    }

    @media (max-width: 320px) {
      padding: 0 25px;
    }
  }

  .f-header {
    font-size: 2.5rem;
    color: $BLACK;
    margin-bottom: 10vh;
    text-align: center;
  }

  .f-sub-header {
    font-size: 1.5rem;
    color: $BLACK;
    margin-bottom: 2vh;
    text-align: left;
    line-height: 1.4;
  }

  .f-sent-email {
    font-size: 1.25rem;
    text-align: center;
    white-space: pre-wrap;
  }

  .form-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 600px;
    width: 40%;

    @media (max-width: 768px) {
      padding: 0 100px;
      width: 100%;
      min-width: 0;
    }

    @media (max-width: 425px) {
      padding: 0 40px;
    }

    @media (max-width: 320px) {
      padding: 0 25px;
    }

    .error-message {
      color: $TOMATO100;
    }

    .form-header {
      text-align: center;
      font-weight: 500;
      color: $N60;
      font-size: 0.875rem;
    }

    .logo-container {
      display: flex;
      align-items: flex-end;
      justify-content: center;
      margin-top: 5rem;

      .logo {
        width: 184px;
        height: 21px;

        @media (max-width: 420px) {
          width: 120px;
          height: 15px;
        }

        @media (max-width: 320px) {
          width: 100px;
          height: 12px;
        }
      }
    }

    .input-container {
      &:not(:last-child) {
        margin-bottom: 18px;
      }

      .input-header {
        font-size: 1rem;
        font-weight: 500;
        margin-bottom: 3px;
      }

      .e-input {
        border: 1px solid $N10;
        width: 100%;
        height: 45px;
        border-radius: 5px;
        padding: 0 10px;

        &:focus {
          background-color: $NBLUE10;
        }
      }
    }

    .send-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 45px;
      background-color: $NBLUE100;
      border-radius: 6px;
      color: $WHITE;
      font-size: 1rem;
      font-weight: 600;
      margin-top: 50px;

      &.disable-btn {
        background-color: $NBLUE20;
      }
    }

    .email-sent {
      margin-top: 50px;

      .e-header {
        text-align: center;
        font-weight: bold;
        color: $N50;
      }

      .e-body {
        text-align: center;
        padding: 1rem;
      }
    }
  }
}
</style>
